// src/AuthProvider.jsx
import React, { createContext, useState, useEffect } from "react";
import { getApiUrl } from "./utils/apiConfig";

// Creamos el contexto
export const AuthContext = createContext({
  account: null,
  login: () => {},
  logout: () => {},
  isLoading: true,
});

// Provider simplificado que usa el backend para autenticación
export const AuthProvider = ({ children }) => {
  const [account, setAccount] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  // Verificar si el usuario está autenticado al cargar
  useEffect(() => {
    const checkAuth = async () => {
      try {
        // console.log('[Auth] Verificando sesión en backend...');
        const response = await fetch(getApiUrl('/api/dashboard-data'), { 
          credentials: 'include' 
        });
        
        if (response.ok) {
          const data = await response.json();
          // console.log('[Auth] Usuario autenticado:', data.user.username);
          setAccount(data.user);
        } else {
          // console.log('[Auth] No hay sesión activa');
          setAccount(null);
        }
      } catch (error) {
        console.error('[Auth] Error verificando autenticación:', error);
        setAccount(null);
      } finally {
        setIsLoading(false);
      }
    };

    checkAuth();
  }, []);

  const login = () => {
    // console.log('[Auth] Redirigiendo a login del backend...');
    window.location.href = getApiUrl('/auth/login');
  };

  const logout = async () => {
    try {
      // console.log('[Auth] Cerrando sesión...');
      await fetch(getApiUrl('/api/logout'), { 
        method: 'POST',
        credentials: 'include' 
      });
      setAccount(null);
      window.location.href = '/';
    } catch (error) {
      console.error('[Auth] Error al cerrar sesión:', error);
    }
  };

  // Mostrar spinner mientras se valida la autenticación
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <div className="text-center">
          <svg className="h-12 w-12 animate-spin mx-auto text-blue-600" viewBox="0 0 24 24" fill="none">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
          </svg>
          <p className="mt-4 text-gray-600 font-medium">Verificando autenticación...</p>
        </div>
      </div>
    );
  }

  return (
    <AuthContext.Provider value={{ account, login, logout, isLoading }}>
      {children}
    </AuthContext.Provider>
  );
};
